import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getTypographyVariant } from '../../typography/Typography';

import Link from '../../link';

export const Nav = styled('nav')`
  width: 100%;
  display: ${props => props.desktopOnly ? 'none': 'flex'};
  flex-direction: row;
  grid-column: main-start / main-end;
  justify-content: space-between;

  @media ${props => props.theme.queries.navbarBreakpoint} {
    display: ${props => props.desktopOnly ? 'flex': 'none'};
  }
`

export const NavUL = styled('ul')`
  display: flex;
  flex-direction: column;
  padding: 0 ${24 / 16}rem ${24 / 16}rem;

  @media ${props => props.theme.queries.navbarBreakpoint} {
    padding: 0;
    flex-direction: row;
    align-items: center;
  }  

  /* Give the li items a bit of breathing room. */
  li {
    padding-top: 12px;
    
    @media ${props => props.theme.queries.navbarBreakpoint} {
      padding-top: 0;
      padding-left: 32px;
    }
  }
`

NavUL.propTypes = {
  expandMobileMenu: PropTypes.bool,
}

export const NavHR = styled('hr')`
  border: 1px solid ${props => props.theme.colors.slate.lightest};
`

export const NavSection = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const DesktopSection = styled('div')`
  display: none;
  @media ${props => props.theme.queries.navbarBreakpoint} {
    display: block;
  }
`

export const MobileSection = styled('div')`
  display: block;
  @media ${props => props.theme.queries.navbarBreakpoint} {
    display: none;
  }
`

export const NavLink = styled(Link)`
  --font-weight: 500;
  color: ${props => props.active ? props.theme.colors.magic.base : props.theme.colors.black};
  fill: ${props => props.active ? props.theme.colors.magic.base : ''};
  @media ${(props) => props.theme.queries.navbarBreakpointDown} {
    ${getTypographyVariant('subheading')}
    /* make link stretch full-width to increase click area */
    display: block;
  }

  &:hover {
    fill: ${props => props.theme.colors.magic.base};
  }

`;
